import { formatHours, formatMoney, formatPercent, longDate, monthLabel, shortDate, weekdayShort, isoWeek, type Language } from '@pz/core';
import i18n from '../i18n';

export function lang(): Language {
  const l = i18n.language as Language;
  return l === 'en' || l === 'tr' ? l : 'de';
}

/** 450 -> "7,50" */
export const h = (minutes: number | null | undefined, decimals = 2) =>
  minutes === null || minutes === undefined ? '-' : formatHours(minutes, lang(), decimals);
/** 450 -> "7,50 h" */
export const hh = (minutes: number | null | undefined, decimals = 2) => (minutes === null || minutes === undefined ? '-' : `${h(minutes, decimals)} h`);
export const money = (cents: number | null | undefined) => (cents === null || cents === undefined ? '-' : formatMoney(cents, lang()));
export const pct = (ratio: number | null | undefined, decimals = 0) =>
  ratio === null || ratio === undefined ? '-' : formatPercent(ratio, lang(), decimals);
/** Range of percentages as the language writes it: "0-20 %" (de), "0-20%" (en), "%0-20" (tr) */
export const pctRange = (from: number, to: number) => (lang() === 'tr' ? `%${from}-${to}` : lang() === 'en' ? `${from}-${to}%` : `${from}-${to} %`);
export const locale = () => (lang() === 'en' ? 'en-GB' : lang() === 'tr' ? 'tr-TR' : 'de-DE');
/** Number in the language of the app: 2.5 -> "2,5" (de, tr), "2.5" (en) */
export const num = (value: number | null | undefined, maxDecimals = 2) =>
  value === null || value === undefined || Number.isNaN(value) ? '-' : new Intl.NumberFormat(locale(), { maximumFractionDigits: maxDecimals }).format(value);
export const d = (iso: string | null | undefined) => (iso ? shortDate(iso.slice(0, 10)) : '-');
export const dLong = (iso: string) => longDate(iso, lang());
export const dt = (iso: string | null | undefined) => {
  if (!iso) return '-';
  const date = new Date(iso);
  return new Intl.DateTimeFormat(locale(), {
    dateStyle: 'short',
    timeStyle: 'short',
    timeZone: 'Europe/Berlin',
  }).format(date);
};
/** clock time of an instant (HH:MM in the language of the screen) */
export const tm = (iso: string | null | undefined) => (iso ? new Intl.DateTimeFormat(locale(), { timeStyle: 'short', timeZone: 'Europe/Berlin' }).format(new Date(iso)) : '-');
export const wd = (iso: string) => weekdayShort(iso, lang());
export const month = (iso: string) => monthLabel(iso, lang());
export const kw = (iso: string) => isoWeek(iso).week;

/** A text as part of a file name: letters, digits, dot, dash and underscore (other characters become "_"). */
export function safeName(s: string): string {
  return s.replace(/[^\p{L}\p{N}._-]+/gu, '_').replace(/_+/g, '_').slice(0, 80);
}
